export const hhmmssToString = (hhmmss: string) => {
    const regex = /^(\d{2,}):([0-5][0-9]):([0-5][0-9])$/
    const addS = (word: string, number: number) => {
        return `${word}${number !== 1 ? "s" : ""}`
    }

    const match = hhmmss.match(regex);
    if (!match) {
        return "0 seconds"
    }
    const [, hours, minutes, seconds] = match.map(token => Number(token));
    return `${hours ? `${hours} ${addS("hour", hours)}, ` : ""}`+
        `${minutes ? `${minutes} ${addS("minute", minutes)}, ` : ""}` +
        `${seconds} ${addS("second", seconds)}`;
}

export const hhmmssToMinutesString = (hhmmss: string) => {
    const regex = /^(\d{2,}):([0-5][0-9]):([0-5][0-9])$/
    const addS = (word: string, number: number) => {
        return `${word}${number !== 1 ? "s" : ""}`
    }

    const match = hhmmss.match(regex);
    if (!match) {
        return "0 seconds"
    }
    const [, hours, minutes, seconds] = match.map(token => Number(token));
    const totalMinutes = (hours * 60 + minutes + seconds / 60);
    return `${totalMinutes.toFixed(2)} ${addS("minute", totalMinutes)}`
}